import { getRandomInt } from '~utils/number';

export function ShareFormatPlaceholder() {
  const w = ['w-2/3', 'w-1/2', 'w-3/4', 'w-4/5'].at(getRandomInt(0, 3));
  return (
    <div className="border-solid border-gray border-b-2 py-3 flex justify-between items-center">
      <div className="flex flex-col w-full gap-1">
        <div className="bg-gray rounded-full h-4 animate-pulse w-1/3" />
        <div className={`bg-gray rounded-full h-4 animate-pulse ${w}`} />
      </div>
    </div>
  );
}
